import { useEffect } from "react";

import { useCurrentUser } from "utils/currentUser";

export const useUmamiIdentify = () => {
  const user = useCurrentUser();
  const userId = user?._id;
  const organisationId = user?.ownerOrganisation?._id;

  useEffect(() => {
    if (!userId || !window.umami?.identify) {
      return;
    }

    window.umami.identify(
      userId,
      organisationId ? { organisation: organisationId } : undefined,
    );
  }, [userId, organisationId]);
};

export default useUmamiIdentify;
